import React, { Component } from 'react';
import RestClientHeaderRow from './RestClientHeaderRow';

export default class RestClientHeaderTab extends Component {
  render() {
    const { projectDetail } = this.props;
    return (
      <div className="row pt-2">
        <div className="col-md-4 col-lg-4">Key</div>
        <div className="col-md-8 col-lg-8">Value</div>
        {this.props.headers.map((row) => {
          return (
            <RestClientHeaderRow
              headerRow={row}
              key={row.id}
              createNewRow={this.props.handleHeaderChange}
              externalapi={this.props.externalapi}
              bodyDataFrom={this.props.bodyDataFrom}
              collectionName={this.props.collectionName}
              home={this.props.home}
              projectDetail={projectDetail}
            />
          );
        })}
      </div>
    );
  }
}
